import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import Tooltip from './Tooltip';
import { formatCurrency } from '../../lib/utils/formatters';

export default function Term({
  parentSelectedTerm,
  setParentTerm,
  term,
  cart,
  promo,
  newLook,
  submitButton,
}) {
  const [selectedTerm, setSelectedTerm] = useState(parentSelectedTerm);
  const isParentSelectedTerm =
    parentSelectedTerm &&
    term &&
    term.get('term') === parentSelectedTerm.term &&
    term.get('term_period') === parentSelectedTerm.term_period;

  useEffect(() => {
    if (setParentTerm) setParentTerm(selectedTerm);
  }, [selectedTerm]);

  const termOnClick = (term) => {
    setSelectedTerm({
      term: parseInt(term.get('term')),
      term_period: term.get('term_period'),
      payment: parseFloat(term.get('monthly_payment')),
    });
  };

  function Interest() {
    const totalInterest = parseFloat(term.get('total_interest'));
    return (
      <>
        <div className="flex flex-col sm:flex-row items-center justify-center text-secondary-gray">
          <p className="text-xs sm:text-sm font-semibold">
            {totalInterest === 0 && 'No'}
            {totalInterest > 0 && formatCurrency(totalInterest)}{' '}
            {totalInterest > 0 && (
              <span className="inline sm:hidden">total </span>
            )}
            interest
          </p>
          <span className="hidden sm:inline text-secondary-gray mx-2 mb-0.5">
            •
          </span>
          {cart && cart.processing_fee > 0.0 && (
            <>
              <p className="text-xs sm:text-sm font-semibold">
                {formatCurrency(term.get('total_fees'))} service fee
              </p>
              <span className="hidden sm:inline text-secondary-gray mx-2 mb-0.5">
                •
              </span>
            </>
          )}
          <p className="text-xs sm:text-sm">
            First payment{' '}
            {term.get('term_period') === 'days'
              ? term.get('term') + 1
              : promo
              ? promo.get('max_net_payment') + 1
              : 31}{' '}
            days after shipment
          </p>
        </div>
      </>
    );
  }

  if (newLook && term && term.get('term_period') === 'biweekly') {
    return (
      <div
        className={classNames(
          'mb-1 p-6 border rounded-2xl my-2.5 mx-auto shadow',
          {
            'cursor-pointer': setParentTerm,
            'border-[3px] border-[#0066FF] shadow-0': isParentSelectedTerm,
          }
        )}
        key={term.get('term')}
        id={'term-' + term.get('term')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
        onClick={() => termOnClick(term)}
      >
        <div className="text-lg sm:text-xl font-semibold mb-2">Pay in 4</div>
        <div className="text-sm sm:text-base text-left">
          4 payments of <span>${term.get('monthly_payment')}, </span>
          starting today.
        </div>
        <div className="text-xs sm:text-sm text-secondary-gray flex justify-initial gap-6 py-1">
          <span>
            <FontAwesomeIcon
              icon={['fas', 'check']}
              className="text-green-600 text-sm sm:text-base mr-2"
            />
            $0 Interest
          </span>
          <span>
            <FontAwesomeIcon
              icon={['fas', 'check']}
              className="text-green-600 text-sm sm:text-base mr-2"
            />
            Every 2 weeks
          </span>
          <span>
            <FontAwesomeIcon
              icon={['fas', 'check']}
              className="text-green-600 text-sm sm:text-base mr-2"
            />
            First payment today
          </span>
        </div>
        {isParentSelectedTerm && submitButton}
      </div>
    );
  }

  if (term && term.get('term_period') === 'biweekly') {
    return (
      <div
        className={classNames(
          'mb-1 p-3 border rounded-md shadow my-2.5 mx-auto',
          {
            'cursor-pointer': setParentTerm,
            'border-[3px] border-success': isParentSelectedTerm,
            'border-secondary-gray':
              parentSelectedTerm && !isParentSelectedTerm,
          }
        )}
        key={term.get('term')}
        id={'term-' + term.get('term')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
        onClick={() => termOnClick(term)}
      >
        <div className="text-sm sm:text-base text-center font-semibold">
          4 payments of{' '}
          <span className="text-success">${term.get('monthly_payment')}</span>
        </div>
        <div className="text-xs sm:text-sm text-center text-secondary-gray flex items-center justify-evenly py-1 sm:px-4">
          $0 Interest
          <span>•</span>
          Every 2 weeks
          <span>•</span>
          First payment today
        </div>
      </div>
    );
  }

  if (newLook && term && term.get('term_period') === 'days') {
    const termDays = term.get('term');
    return (
      <div
        className={classNames(
          'mb-1 p-6 border rounded-2xl my-2.5 mx-auto shadow',
          {
            'cursor-pointer': setParentTerm,
            'border-[3px] border-[#0066FF] shadow-0': isParentSelectedTerm,
          }
        )}
        key={term.get('term')}
        id={'term-' + term.get('term')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
        onClick={() => termOnClick(term)}
      >
        <div className="text-lg sm:text-xl font-semibold mb-2">
          Net {termDays}
        </div>
        <div className="text-sm sm:text-base text-left">
          Pay in full within {termDays} days
        </div>
        <div className="text-xs sm:text-sm text-secondary-gray flex justify-initial gap-6 py-1 mb-4">
          <span>
            <FontAwesomeIcon
              icon={['fas', 'check']}
              className="text-sm text-green-600 sm:text-base mr-2"
            />
            0% Interest
          </span>
          <span>
            <FontAwesomeIcon
              icon={['fas', 'check']}
              className="text-sm text-green-600 sm:text-base mr-2"
            />
            No payment today
          </span>
          <span>
            <FontAwesomeIcon
              icon={['fas', 'check']}
              className="text-sm text-green-600 sm:text-base mr-2"
            />
            Due in {termDays} days
          </span>
        </div>
        <div className="rounded-lg bg-gray-50 p-4 mb-4">
          <div className="flex justify-between">
            <div>Total Due</div>
            <div className="font-semibold">
              {formatCurrency(term.get('monthly_payment'))}
            </div>
          </div>
          <div className="flex justify-between">
            <div>Due Date</div>
            <div className="font-semibold">{termDays} days from shipment</div>
          </div>
        </div>
        {isParentSelectedTerm && submitButton}
      </div>
    );
  }

  if (term && term.get('available')) {
    return (
      <div
        className={classNames('border rounded-md shadow p-2.5 my-2.5 mx-auto', {
          'cursor-pointer': setParentTerm,
          'border-[3px] border-success': isParentSelectedTerm,
          'border-secondary-gray': parentSelectedTerm && !isParentSelectedTerm,
        })}
        key={term.get('term')}
        id={'term-' + term.get('term')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
        onClick={() => termOnClick(term)}
      >
        <div className="flex-1 whitespace-nowrap">
          <div className="flex items-center justify-center space-x-3 mb-1 sm:mb-0">
            <h3 className="text-sm sm:text-lg font-semibold">
              {term.get('term_period') === 'days' ? (
                <span className="mx-1">Net {term.get('term')}</span>
              ) : (
                <span className="text-sm sm:text-base">
                  {term.get('term')}{' '}
                  {term.get('term') === 1 ? ' month ' : ' monthly payments of '}
                </span>
              )}
              <span className="text-success ml-1">
                {formatCurrency(term.get('monthly_payment'))}
              </span>
            </h3>
          </div>
          <div className="text-center text-lg">{Interest()}</div>
        </div>
      </div>
    );
  }

  if (term && !term.get('available')) {
    return (
      <div
        className="mb-4 border rounded-md shadow p-3 my-2.5 mx-auto term-unavailable"
        key={term.get('id')}
        id={'term-' + term.get('id')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
      >
        <div className="text-center">
          <div>
            <p>
              <div className="text-sm sm:text-lg font-semibold">
                {term.get('term')} {term.get('term') === 1 ? 'month' : 'months'}
              </div>
            </p>
          </div>
          <div>
            <div className="text-error font-semibold">
              <span className="mx-1">Unavailable</span>
              <Tooltip
                tooltipText="This option exceeds your payback capacity"
                placement="top-start"
                triggerClass="px-0.5 mt-1 text-xs sm:text-sm hover:cursor-pointer hover:text-primary-blue text-left"
                containerClass="rounded-lg w-72 p-3 bg-border-gray text-xs"
              >
                <FontAwesomeIcon
                  icon={['fal', 'info-circle']}
                  className="text-sm sm:text-base"
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
